import { useEffect } from "react";

const SITE_ORIGIN = "https://buildoncestudio.com";

/**
 * Ensures a <meta> or <link> tag with the given selector exists in <head>,
 * creating it lazily if missing, then sets the specified attribute.
 */
function upsertHeadTag(selector, tagName, attrs) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement(tagName);
    Object.entries(attrs.create || {}).forEach(([k, v]) => tag.setAttribute(k, v));
    document.head.appendChild(tag);
  }
  Object.entries(attrs.set || {}).forEach(([k, v]) => tag.setAttribute(k, v));
}

/**
 * Sets document.title, meta description, canonical, and per-route Open
 * Graph + Twitter card tags. Keeps og:image sitewide (defined in
 * public/index.html). Path defaults to window.location.pathname.
 */
export default function useSeo({ title, description, path }) {
  useEffect(() => {
    const routePath = path || (typeof window !== "undefined" ? window.location.pathname : "/");
    const canonicalUrl = SITE_ORIGIN + (routePath === "/" ? "/" : routePath.replace(/\/$/, ""));

    if (title) document.title = title;

    if (description) {
      upsertHeadTag('meta[name="description"]', "meta", {
        create: { name: "description" },
        set: { content: description },
      });
    }

    upsertHeadTag('link[rel="canonical"]', "link", {
      create: { rel: "canonical" },
      set: { href: canonicalUrl },
    });

    if (title) {
      upsertHeadTag('meta[property="og:title"]', "meta", {
        create: { property: "og:title" },
        set: { content: title },
      });
      upsertHeadTag('meta[name="twitter:title"]', "meta", {
        create: { name: "twitter:title" },
        set: { content: title },
      });
    }
    if (description) {
      upsertHeadTag('meta[property="og:description"]', "meta", {
        create: { property: "og:description" },
        set: { content: description },
      });
      upsertHeadTag('meta[name="twitter:description"]', "meta", {
        create: { name: "twitter:description" },
        set: { content: description },
      });
    }
    upsertHeadTag('meta[property="og:url"]', "meta", {
      create: { property: "og:url" },
      set: { content: canonicalUrl },
    });
  }, [title, description, path]);
}
